module.exports = __webpack_public_path__ + "ss.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ss.svg
// module id = 818
// module chunks = 0